import { render, staticRenderFns } from "./editTable.vue?vue&type=template&id=0a5dfa16"
import script from "./editTable.vue?vue&type=script&lang=js"
export * from "./editTable.vue?vue&type=script&lang=js"
import style0 from "./editTable.vue?vue&type=style&index=0&id=0a5dfa16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports